module.exports = __webpack_public_path__ + "img/Sushiswap.3c6d4bb5.png";